export interface IAddressTypeOptions {
  label: string;
  value: string;
}

export const addressTypeOptions: IAddressTypeOptions[] = [
  {
    value: 'NotSet',
    label: 'Not Set',
  },
  {
    value: 'OwnsFreeClear',
    label: 'Owns Free & Clear',
  },
  {
    value: 'Rent',
    label: 'Rent',
  },
  {
    value: 'Parents',
    label: 'Parents',
  },
  {
    value: 'Military',
    label: 'Military',
  },
  {
    value: 'Mortgage',
    label: 'Mortgage',
  },
  {
    value: 'Lease',
    label: 'Lease',
  },
  {
    value: 'Boards',
    label: 'Boards',
  },
];
